/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BrandAndMarketListItemAutocompleteResult,
    BrandAndMarketListItemAutocompleteResultFromJSON,
    BrandAndMarketListItemAutocompleteResultToJSON,
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UserPermissionsBrandAndMarketFilter,
    UserPermissionsBrandAndMarketFilterFromJSON,
    UserPermissionsBrandAndMarketFilterToJSON,
} from '../models';

export interface ApiUserPermissionsBrandAndMarketAutoCompletePostRequest {
    userPermissionsBrandAndMarketFilter?: UserPermissionsBrandAndMarketFilter;
}

/**
 * no description
 */
export class UserPermissionsBrandAndMarketAutoCompleteApi extends runtime.BaseAPI {

    /**
     */
    async apiUserPermissionsBrandAndMarketAutoCompletePostRaw(requestParameters: ApiUserPermissionsBrandAndMarketAutoCompletePostRequest): Promise<runtime.ApiResponse<BrandAndMarketListItemAutocompleteResult>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/UserPermissionsBrandAndMarketAutoComplete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserPermissionsBrandAndMarketFilterToJSON(requestParameters.userPermissionsBrandAndMarketFilter),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BrandAndMarketListItemAutocompleteResultFromJSON(jsonValue));
    }

    /**
     */
    async apiUserPermissionsBrandAndMarketAutoCompletePost(requestParameters: ApiUserPermissionsBrandAndMarketAutoCompletePostRequest): Promise<BrandAndMarketListItemAutocompleteResult> {
        const response = await this.apiUserPermissionsBrandAndMarketAutoCompletePostRaw(requestParameters);
        return await response.value();
    }

}
